import "babel-polyfill";

import d3 from "d3";
import React from "react";
import ReactDOM from "react-dom";

/*****************************************************************/
var DateFilter = React.createClass({
  getInitialState: function() {
    var earliest_start_year = new Date(d3.min(this.props.data, function(d, i) { return d.Start_Date; })).getFullYear()
    var latest_end_year = new Date(d3.max(this.props.data, function(d, i) { return d.End_Date; })).getFullYear();

    return {
      months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
      years: d3.range(+earliest_start_year, +latest_end_year + 2),
    }
  },

  render: function() {
    var props = this.props;
    return (
      <div id="date_filter">
        <div className="dateFilterRow">
          <div className="datePicker">
            <span className="filterLabel">Start Month</span>
            <div className="box dropdown" value="startMonthClasses" onClick={this.props.showDropdown}>{this.props.startMonth} <span value="startMonthClasses" className="glyphicon glyphicon-triangle-bottom"></span></div>
              <div className={this.props.startMonthClasses}>
                {this.state.months.map(month => {
                  return (
                    <div key={month} className={month === props.startMonth ? "choices chosen" : "choices"} onClick={this.props.setStartMonth} value={month}>{month}</div>
                  );
                })}
              </div>
          </div>
          <div className="datePicker right">
            <span className="filterLabel">Start Year</span>
            <div className="box dropdown" value="startYearClasses" onClick={this.props.showDropdown}>{this.props.startYear} <span value="startYearClasses" className="glyphicon glyphicon-triangle-bottom"></span></div>
              <div className={this.props.startYearClasses}>
                {this.state.years.map(year => {
                  return (
                    <div key={year} className={year === props.startYear ? "choices chosen" : "choices"} onClick={this.props.setStartYear} value={year}>{year}</div>
                  );
                })}
            </div>
          </div>
          <div className="clearfix"></div>
        </div>
        <div className="dateFilterRow bottom">
          <div className="datePicker">
            <span className="filterLabel">End Month</span>
            <div className="box dropdown" value="endMonthClasses" onClick={this.props.showDropdown}>{this.props.endMonth} <span value="endMonthClasses" className="glyphicon glyphicon-triangle-bottom"></span></div>
              <div className={this.props.endMonthClasses}>
                {this.state.months.map(month => {
                  return (
                    <div key={month} className={month === props.endMonth ? "choices chosen" : "choices"} onClick={this.props.setEndMonth} value={month}>{month}</div>
                  );
                })}
              </div>
          </div>
          <div className="datePicker right">
            <span className="filterLabel">End Year</span>
            <div className="box dropdown" value="endYearClasses" onClick={this.props.showDropdown}>{this.props.endYear} <span value="endYearClasses" className="glyphicon glyphicon-triangle-bottom"></span></div>
              <div className={this.props.endYearClasses}>
                {this.state.years.map(year => {
                  return (
                    <div key={year} className={year === props.endYear ? "choices chosen" : "choices"} onClick={this.props.setEndYear} value={year}>{year}</div>
                  );
                })}
            </div>
          </div>
          <div className="clearfix"></div>
        </div>
      </div>
    );
  }
});

/*****************************************************************/
var RegionFilter = React.createClass({
  render: function() {
    // compute number of vaccines selected to display in rolled-up dropdown
    var numRegionsChosen = 0;
    var rL = this.props.allRegionsList;
    var r = this.props.regions;
    var reg = "";
    var rollup = "";

    rL.forEach(region => {
      if (r[region] === true && region.toUpperCase() != "SELECT ALL") { // select all is not a region
        numRegionsChosen += 1;
        reg = region;
      }
    });

    if (numRegionsChosen === 1) {
      rollup = reg;
    } else {
      rollup = numRegionsChosen + " Regions Selected";
    }

    return (
      <div id="region_filter">
        <span className="filterLabel">Region</span>
        <div className="box dropdown" value="regionChoicesClasses" onClick={this.props.showDropdown}>{rollup} <span value="regionChoicesClasses" className="glyphicon glyphicon-triangle-bottom"></span></div>
        <div className={this.props.regionChoicesClasses}>
          {this.props.allRegionsList.map(region => {
            return (
              <div key={region} className="choices">
                <input
                  type="checkbox"
                  className="choices"
                  value={region}
                  onChange={this.props.selectRegion}
                  checked={(() => {
                    return this.props.regions[region];
                  })()}/>
                <div className="choice">{region}</div>
              </div>
            );
          })}
        </div>
        <CountryFilter
          data={this.props.data}
          selectCountry={this.props.selectCountry}
          regions={this.props.regions}
          allRegionsList={this.props.allRegionsList}
          countries={this.props.countries}
          countriesList={this.props.countriesList}
          countryChoicesClasses={this.props.countryChoicesClasses}
          showDropdown={this.props.showDropdown} />
      </div>
    );
  }
});

/*****************************************************************/
var CountryFilter = React.createClass({ // countries populate according to the regions that were selected
  render: function() {
    // compute number of vaccines selected to display in rolled-up dropdown
    var numCountriesChosen = 0;
    var cL = this.props.countriesList;
    var c = this.props.countries;
    var cnt = "";
    var rollup = "";

    cL.forEach(country => {
      if (c[country] === true && country.toUpperCase() != "SELECT ALL") { // Select All is not a country
        numCountriesChosen += 1;
        cnt = country;
      }
    });

    if (numCountriesChosen === 1) {
      rollup = cnt;
    } else {
      rollup = numCountriesChosen + " Countries Selected";
    }

    return (
      <div id="country_filter" className="bottom">
        <span className="filterLabel">Countries</span>
        <div className="box dropdown" value="countryChoicesClasses" onClick={this.props.showDropdown}>{rollup} <span value="countryChoicesClasses" className="glyphicon glyphicon-triangle-bottom"></span></div>
        <div className={this.props.countryChoicesClasses}>
          {this.props.countriesList.map(country => {
            return (
              <div key={country} className="choices">
              <input
                type="checkbox"
                className="choices"
                value={country}
                onChange={this.props.selectCountry}
                checked={(() => {
                  return this.props.countries[country];
                })()} />
                <span className="choice">{country}</span>
              </div>
            );
          })}
        </div>
      </div>
    );
  }
});

/*****************************************************************/
var VaccineFilter = React.createClass({
  render: function() {
    // compute number of vaccines selected to display in rolled-up dropdown
    var numVaccinesChosen = 0;
    var vL = this.props.allVaccinesList;
    var v = this.props.vaccines;
    var vac = "";
    var rollup = "";

    vL.forEach(vaccine => {
      if (v[vaccine] === true && vaccine.toUpperCase() != "SELECT ALL") { // Select All is not a vaccine
        numVaccinesChosen += 1;
        vac = vaccine;
      }
    });

    if (numVaccinesChosen === 1) {
      rollup = vac;
    } else {
      rollup = numVaccinesChosen + " Vaccines Selected";
    }

    return (
      <div id="vaccine_filter">
        <span className="filterLabel">Vaccine</span>
        <div className="box dropdown" value="vaccineChoicesClasses" onClick={this.props.showDropdown}>{rollup}<span value="vaccineChoicesClasses" className="glyphicon glyphicon-triangle-bottom"></span></div>
        <div className={this.props.vaccineChoicesClasses}>
          {this.props.allVaccinesList.map(vaccine => {
            return (
              <div key={vaccine} className="choices">
                <input
                  type="checkbox"
                  className="choices"
                  value={vaccine}
                  onChange={this.props.selectVaccine}
                  checked={(() => {
                    return this.props.vaccines[vaccine];
                  })()} />
                <span className="choice">{vaccine}</span>
              </div>
            );
          })}
        </div>
      </div>
    );
  }
});

/*****************************************************************/
var ActivityFilter = React.createClass({
  render: function() {
    // compute number of activities selected to display in rolled-up dropdown
    var numActivitiesChosen = 0;
    var aL = this.props.allActivitiesList;
    var a = this.props.activities;
    var act = "";
    var rollup = "";

    aL.forEach(activity => {
      if (a[activity] === true  && activity.toUpperCase() != "SELECT ALL") { // Select All is not an activity
        numActivitiesChosen += 1;
        act = activity;
      }
    });

    if (numActivitiesChosen === 1) {
      rollup = act;
    } else {
      rollup = numActivitiesChosen + " Activities Selected";
    }

    return (
      <div id="activity_filter" className="bottom">
        <span className="filterLabel">Activity</span>
        <div className="box dropdown" value="activityChoicesClasses" onClick={this.props.showDropdown}>{rollup}<span value="activityChoicesClasses" className="glyphicon glyphicon-triangle-bottom"></span></div>
        <div className={this.props.activityChoicesClasses}>
          {this.props.allActivitiesList.map(activity => {
            return (
              <div key={activity} className="choices">
                <input
                  type="checkbox"
                  className="choices"
                  value={activity}
                  onChange={this.props.selectActivity}
                  checked={(() => {
                    return this.props.activities[activity];
                  })()} />
                <span className="choice">{activity}</span>
              </div>
            );
          })}
        </div>
      </div>
    );
  }

});

/*****************************************************************/
var Key = React.createClass({
  render: function() {
    var p = this.props;
    return (
      <div id="key">
        <div id="region">
          <span className="title">Region</span>
          {p.allRegionsList.filter(region => {
            return region.toUpperCase() != "SELECT ALL"; // need this, but its not a region
          }).filter(region => {
            return p.regions[region] == true;
          }).map(region => {
            return <span key={region} className="entry">{region}</span>;
          })}
        </div>
        <div id="country">
          <span className="title">Country</span>
          {p.countriesList.filter(country => {
            return country.toUpperCase() != "SELECT ALL"; // need this, but its not a country
          }).filter(country => {
            return p.countries[country] == true;
          }).map(country => {
            return <span key={country} className="entry">{country}</span>;
          })}
        </div>
        <div id="vaccine">
          <span className="title">Vaccine</span>
          {p.allVaccinesList.filter(vaccine => {
            return vaccine.toUpperCase() != "SELECT ALL"; // need this, but its not a vaccine
          }).filter(vaccine => {
            return p.vaccines[vaccine] == true;
          }).map(vaccine => {
            return <span key={vaccine} className={`entry ${vaccine.replace(/[\+\s]/g, "_").toLowerCase()}`}>{vaccine}</span>;
          })}
        </div>
        <div id="activity">
          <span className="title">Activity</span>
          {p.allActivitiesList.filter(activity => {
            return activity.toUpperCase() != "SELECT ALL"; // need this, but its not an activity
          }).filter(activity => {
            return p.activities[activity] == true;
          }).map(activity => {
            return <span key={activity} className="entry">{activity}</span>;
          })}
        </div>
      </div>
    );
  }
});

/*****************************************************************/
var Cal = React.createClass({
  render: function() {
    // filter the data based on all the filters selected, draw the results
    var p = this.props;
    var startMonth = p.startMonth;
    var startYear = +p.startYear;
    var endMonth = p.endMonth;
    var endYear = +p.endYear;
    var euroTimeFormat = d3.time.format("%d-%b-%Y");

    //var monthsArr = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    var monthsArr = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

    var months = {
      January: 0,
      February: 1,
      March: 2,
      April: 3,
      May: 4,
      June: 5,
      July: 6,
      August: 7,
      September: 8,
      October: 9,
      November: 10,
      December: 11
    };

    var timeHeaders = [];

    if (endYear == startYear) { // difference is only in months
      d3.range(months[startMonth], months[endMonth]+1).forEach(monthIndex => {
        timeHeaders.push(monthsArr[monthIndex] + ", " + startYear);
      });
    } else if (endYear > startYear) { // difference is across years
      d3.range(startYear, endYear+1).forEach(year => {
        if (year == startYear) {
          d3.range(months[startMonth], 12).forEach(monthIndex => {
            timeHeaders.push(monthsArr[monthIndex] + ", " + year);
          });
        } else if (year == endYear) {
          d3.range(0, months[endMonth]+1).forEach(monthIndex => {
            timeHeaders.push(monthsArr[monthIndex] + ", " + year);
          });
        } else { // run the full year
          d3.range(0, 12).forEach(monthIndex => {
            timeHeaders.push(monthsArr[monthIndex] + ", " + year);
          });
        }
      });
    }

    // filter down squares to contain activity, vaccine, and timestamp
    // plot them by month, year, and country
    var calendarData = {}; // bacon like chips -> { "angola": {"Mar, 2016": "", "Apr, 2016": "", "May, 2016", "tOPV, NID, date"}, "brazil": {} }
    var countriesListToDraw = p.countriesList.filter(country => {
      return country.toUpperCase() != "SELECT ALL"; // its not a country
    }).filter(country => {
      return p.countries[country] == true;
    });

    var vaccinesChosen = p.allVaccinesList.filter(v => {
      return v.toUpperCase() != "SELECT ALL"; // its not a vaccine
    }).filter(v => { // i feel like i continually do this pattern... idk
      return p.vaccines[v] === true;
    });

    var activitiesChosen = p.allActivitiesList.filter(a => {
      return a.toUpperCase() != "SELECT ALL"; // its not an activity
    }).filter(a => {
      return p.activities[a] === true;
    });

    countriesListToDraw.forEach(country => { // iterate over chosen countries
      calendarData[country] = {};
      timeHeaders.forEach(month => { // iterate over each time entry
        var time = month.split(",");
        calendarData[country][month] = p.data.filter(d => { // filter down the vaccine/activity per country per time entry
          return (+d.Year == +time[1] && d.Start_Month == time[0] && d.Country == country && vaccinesChosen.indexOf(d.Vaccine) > -1 && activitiesChosen.indexOf(d.ActivityType) > -1);
        });
      });
    });

    return (
      <div id="table_container">
        <table>
          <thead>
            <tr>
              <th className="calCountryHeader">Country</th>
              {timeHeaders.map(month => { // its Month, Year
                return <th key={month}>{month}</th>;
              })}
            </tr>
          </thead>
          <tbody>
            {countriesListToDraw.map((country, i) => {
              var stripe = !(i % 2); // !! to start table without a striped tr
              // draw entries across time per country
              var rowsPerCountry = timeHeaders.map(month => { // get # of rows needed per country
                return calendarData[country][month].length;
              }).reduce((prev, next) => {
                return (next > prev ? next : prev);
              }, 1);

              return d3.range(0, rowsPerCountry).map(r => {
                return (
                  <tr className={stripe ? "stripe" : "noStripe"}>
                    <td className="calCountryLabel">{country}</td>
                    {timeHeaders.map(month => {
                      if (calendarData[country][month][r] !== undefined) {
                        return (
                          <td key={month} className={calendarData[country][month][r].Vaccine.replace(/[\+\s]/g, "_").toLowerCase()}>
                            <div>{calendarData[country][month][r].Vaccine}</div>
                            <div>{calendarData[country][month][r].ActivityType}</div>
                            <div>{euroTimeFormat(new Date(calendarData[country][month][r].Start_Date))}</div>
                          </td>
                        );
                      } else {
                        return (
                          <td key={month}></td>
                        );
                      }
                    })}
                  </tr>
                );
              });
            })}
          </tbody>
        </table>
      </div>
    );
  }
});

/*****************************************************************/
var FilterableCal = React.createClass({
  getInitialState: function() {
    return {
      regions: this.props.regions,
      countries: {}, // countries are keys, true/false based on whether you selected that country
      countriesList: [], // list of all possible countries to choose from, based on the regions selections
      vaccines: this.props.vaccines,
      activities: this.props.activities,
      startYear: "",
      startMonth: "",
      endYear: "",
      endMonth: "",
      dropdownClassesKeys: ["startMonthClasses", "endMonthClasses", "startYearClasses", "endYearClasses", "regionChoicesClasses", "countryChoicesClasses", "vaccineChoicesClasses", "activityChoicesClasses"],
      dropdownClasses: {
        startMonthClasses: "box hide",
        endMonthClasses: "box hide",
        startYearClasses: "box hide",
        endYearClasses: "box hide",
        regionChoicesClasses: "box hide",
        countryChoicesClasses: "box hide",
        vaccineChoicesClasses: "box hide",
        activityChoicesClasses: "box hide"
      }
    }
  },

  componentDidMount: function() { // since the cal is loading with everything selected, put the country stuff here, as well as in selectRegion's handler
    // initially, every country is selected
    var countriesInRegions = [];

    this.props.allRegionsList.forEach(r => {
      countriesInRegions = countriesInRegions.concat(this.props.data.filter(d => {
        return d.Region == r;
      }));
    });

    var countries = {};
    countriesInRegions.map(d => {
      return d.Country;
    }).forEach(d => {
      /*if (d == "AFGHANISTAN" || d == "PAKISTAN") {
        countries[d] = true;
      } else {
        countries[d] = false;
      }*/
      countries[d] = true;
    });

    var countriesList = d3.keys(countries).sort();
    if (countriesList.length > 0) { // add the option to select all countries if there are any countries to choose from
      countriesList.unshift("SELECT ALL");
    }

    // set initial time to be the next three months.
    var startDate = new Date();
    var endDate = new Date();
    endDate.setMonth(startDate.getMonth() + 3); // does next 3 months include the current month?

    var monthMap = {
      0: "January",
      1: "February",
      2: "March",
      3: "April",
      4: "May",
      5: "June",
      6: "July",
      7: "August",
      8: "September",
      9: "October",
      10: "November",
      11: "December"
    };

    this.setState({
      countriesList: countriesList,
      countries: countries,
      startYear: startDate.getFullYear(),
      startMonth: monthMap[startDate.getMonth()],
      endYear: endDate.getFullYear(),
      endMonth: monthMap[endDate.getMonth()]
    });
  },

  selectRegion: function(e) { // selecting regions affects the countries shown
    var regions = this.state.regions;
    var selection = e.target.getAttribute("value");

    // toggle the region selection made by user
    regions[selection] = !regions[selection];

    // did they chose "Select All"?
    if (selection.toUpperCase() == "SELECT ALL") {
      if (regions[selection] === true) { // they chose "Select All"
        this.props.allRegionsList.forEach(region => {
          regions[region] = true;
        });
      } else { // they unselected "Select All"
        this.props.allRegionsList.forEach(region => {
          regions[region] = false;
        });
      }
    } else { // they didn't choose "Select All", so make sure its unselected
      regions["SELECT ALL"] = false;
    }

    // compute the countries right here based on the region selection
    var countriesInRegions = [];

    this.props.allRegionsList.forEach(r => {
      if (regions[r] == true) { // this region selected
        countriesInRegions = countriesInRegions.concat(this.props.data.filter(d => {
          return d.Region == r;
        }));
      }
    });

    var countries = {};
    countriesInRegions.map(d => {
      return d.Country;
    }).forEach(d => {
      countries[d] = false; // could be true or false, doesn't matter since its not being set in state. just getting a list of countries here
    });

    var countriesList = d3.keys(countries);
    if (countriesList.length > 0) { // add the option to select all countries if there are any countries to choose from
      countriesList.unshift("SELECT ALL");
    }

    this.setState({
      regions: regions,
      countriesList: countriesList,
    });
  },

  selectCountry: function(e) {
    var countries = this.state.countries;
    var selection = e.target.getAttribute("value");

    // first, toggle the selection made by the user
    countries[selection] = !countries[selection];

    // are they pushing "SELECT ALL"?
    if (selection.toUpperCase() == "SELECT ALL") {
      if (countries[selection] === true) { // they checked "Select All"
        this.state.countriesList.forEach(country => {
          countries[country] = true;
        });
      } else { // they un-checked "Select All"
        this.state.countriesList.forEach(country => {
          countries[country] = false;
        });
      }
    } else { // they didn't choose "Select All", so make sure its unselected
      countries["SELECT ALL"] = false;
    }

    this.setState({
      countries: countries
    });
  },

  selectVaccine: function(e) {
    var vaccines = this.state.vaccines;
    var selection = e.target.getAttribute("value");

    // first, toggle the selection made by the user
    vaccines[selection] = !vaccines[selection];

    // are they pushing "SELECT ALL"?
    if (selection.toUpperCase() == "SELECT ALL") {
      if (vaccines[selection] === true) { // they checked "Select All"
        this.props.allVaccinesList.forEach(vaccine => {
          vaccines[vaccine] = true;
        });
      } else { // they un-checked "Select All"
        this.props.allVaccinesList.forEach(vaccine => {
          vaccines[vaccine] = false;
        });
      }
    } else { // they didn't choose "Select All", so make sure its unselected
      vaccines["SELECT ALL"] = false;
    }

    this.setState({
      vaccines: vaccines
    });
  },

  selectActivity: function(e) {
    var activities = this.state.activities;
    var selection = e.target.getAttribute("value");

    // first, toggle the selection made by the user
    activities[selection] = !activities[selection];

    // are they pushing "SELECT ALL"?
    if (selection.toUpperCase() == "SELECT ALL") {
      if (activities[selection] === true) { // they checked "Select All"
        this.props.allActivitiesList.forEach(activity => {
          activities[activity] = true;
        });
      } else { // they un-checked "Select All"
        this.props.allActivitiesList.forEach(activity => {
          activities[activity] = false;
        });
      }
    } else { // they didn't choose "Select All", so make sure its unselected
      activities["SELECT ALL"] = false;
    }

    this.setState({
      activities: activities
    });
  },

  setStartYear: function(e) {
    this.setState({
      dropdownClasses: {
        ...this.state.dropdownClasses,
        startYearClasses: "box hide"
      },
      startYear: e.target.getAttribute("value")
    });
  },

  setStartMonth: function(e) {
    this.setState({
      dropdownClasses: {
        ...this.state.dropdownClasses,
        startMonthClasses: "box hide"
      },
      startMonth: e.target.getAttribute("value")
    });
  },

  setEndYear: function(e) {
    this.setState({
      dropdownClasses: {
        ...this.state.dropdownClasses,
        endYearClasses: "box hide"
      },
      endYear: e.target.getAttribute("value")
    });
  },

  setEndMonth: function(e) {
    this.setState({
      dropdownClasses: {
        ...this.state.dropdownClasses,
        endMonthClasses: "box hide"
      },
      endMonth: e.target.getAttribute("value")
    });
  },

  /* dropdown opening/closing code because opening any dropdown needs to close all other open ones */
  showDropdown: function(e) {
    var selectedDropdown = e.target.getAttribute("value");
    var dropdownClasses = this.state.dropdownClasses;
    var unselectedDropdowns = this.state.dropdownClassesKeys.filter(c => {
        return c !== selectedDropdown;
    });

    if (dropdownClasses[selectedDropdown].indexOf("show") > -1) {
      // hide it. easy
      dropdownClasses[selectedDropdown] = "box hide";
    } else { // show it. hide everything else.
      dropdownClasses[selectedDropdown] = "box show";
      unselectedDropdowns.forEach(c => {
        // set state on each item in this array of unselected dropdowns
        dropdownClasses[c] = "box hide";
      });
    }

    this.setState(dropdownClasses);
  },

  render: function() {
    return (
      <div>
        <div id="filters">
          <DateFilter
            data={this.props.data}
            getYear={d3.time.format("%Y")}
            timeformat={d3.time.format("%x")}
            setStartYear={this.setStartYear}
            setStartMonth={this.setStartMonth}
            setEndYear={this.setEndYear}
            setEndMonth={this.setEndMonth}
            startYear={this.state.startYear}
            endYear={this.state.endYear}
            startMonth={this.state.startMonth}
            endMonth={this.state.endMonth}
            startMonthClasses={this.state.dropdownClasses.startMonthClasses}
            startYearClasses={this.state.dropdownClasses.startYearClasses}
            endMonthClasses={this.state.dropdownClasses.endMonthClasses}
            endYearClasses={this.state.dropdownClasses.endYearClasses}
            showDropdown={this.showDropdown} />
          <RegionFilter
            type="Region"
            data={this.props.data}
            selectRegion={this.selectRegion}
            selectCountry={this.selectCountry}
            allRegionsList={this.props.allRegionsList}
            countriesList={this.state.countriesList}
            regions={this.state.regions}
            countries={this.state.countries}
            updateCountries={this.updateCountries}
            regionChoicesClasses={this.state.dropdownClasses.regionChoicesClasses}
            countryChoicesClasses={this.state.dropdownClasses.countryChoicesClasses}
            showDropdown={this.showDropdown} />
          <div id="vaccine_and_activity_filters">
            <VaccineFilter
              type="Vaccine"
              data={this.props.data}
              selectVaccine={this.selectVaccine}
              allVaccinesList={this.props.allVaccinesList}
              vaccines={this.state.vaccines}
              vaccineChoicesClasses={this.state.dropdownClasses.vaccineChoicesClasses}
              showDropdown={this.showDropdown} />
            <ActivityFilter
              type="Activity"
              data={this.props.data}
              selectActivity={this.selectActivity}
              allActivitiesList={this.props.allActivitiesList}
              activities={this.state.activities}
              activityChoicesClasses={this.state.dropdownClasses.activityChoicesClasses}
              showDropdown={this.showDropdown} />
          </div>
          <div className="clearfix"></div>
        </div>
        <Key
          allRegionsList={this.props.allRegionsList}
          countriesList={this.state.countriesList}
          regions={this.state.regions}
          countries={this.state.countries}
          allVaccinesList={this.props.allVaccinesList}
          vaccines={this.state.vaccines}
          allActivitiesList={this.props.allActivitiesList}
          activities={this.state.activities} />
        <Cal
          data={this.props.data}
          allRegionsList={this.props.allRegionsList}
          countriesList={this.state.countriesList}
          regions={this.state.regions}
          countries={this.state.countries}
          allVaccinesList={this.props.allVaccinesList}
          vaccines={this.state.vaccines}
          allActivitiesList={this.props.allActivitiesList}
          activities={this.state.activities}
          startMonth={this.state.startMonth}
          startYear={this.state.startYear}
          endMonth={this.state.endMonth}
          endYear={this.state.endYear} />
      </div>
    );
  }
});

/*****************************************************************/
d3.json("https://extranet.who.int/maps/rest/services/POLIOWEBSITE/Poliowebsite_layers/MapServer/6/query?where=1%3D1&outFields=*&returnGeometry=false&f=json", function(err, raw) {
  if (err) {
    throw err;
  }

  var allRegions = {};
  var allVaccines = {};
  var allActivities = {};

  var getMonth = d3.time.format("%b");

  var data = raw.features.map(d => {
    return d.attributes;
  });

  data.forEach(d => {
    d.Start_Month = getMonth(new Date(d.Start_Date));
    allRegions[d.Region] = true;
    allVaccines[d.Vaccine] = true;
    allActivities[d.ActivityType] = true;
  });

  var regionsList = d3.keys(allRegions).sort();
  regionsList.unshift("SELECT ALL");

  var vaccineList = d3.keys(allVaccines).sort();
  vaccineList.unshift("SELECT ALL");

  var activitiesList = d3.keys(allActivities).sort();
  activitiesList.unshift("SELECT ALL");

  ReactDOM.render(
    <FilterableCal
      data={data}
      allRegionsList={regionsList}
      regions={allRegions}
      allVaccinesList={vaccineList}
      vaccines={allVaccines}
      allActivitiesList={activitiesList}
      activities={allActivities} />,

    document.getElementById("calendar")
  );
});



/** WEBPACK FOOTER **
 ** ./src/index.jsx
 **/